import { Injectable, NgZone } from '@angular/core';

import { IdleCallbackService } from '../../shared/services/idle-callback.service';
import { Performance } from '../../shared/services/performance.service';
import { WindowService } from '../../shared/services/window.service';

@Injectable()
export class PwaIdleCallbackService implements IdleCallbackService {
    constructor(
        private readonly ngZone: NgZone,
        private readonly windowService: WindowService
    ) {
    }

    public runWhenIdle(callback: (deadline?: any) => void): any {
        return this.ngZone.run(() => {
            const start = Performance.now();
            const wrappedCallback = () => callback({
                didTimeout: false,
                timeRemaining: () => Math.max(0, 50 - (Performance.now() - start))
            });
            return this.windowService.nativeWindow.MSApp.execAsyncAtPriority(wrappedCallback, this.windowService.nativeWindow.MSApp.IDLE);
        });
    }

    public cancelIdleCallback(_handle: any): void {
        /* do nothing */
    }
}
